export default { sha: '9e6dff539d345f68c948bf145f59b123706687a4', buildNumber: 'undefined' }
